export { default } from './PaginationItem';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/lab/esm/PaginationItem/index.js
// module id = 1681
// module chunks = 121